export default {

    data() {

        return {

            'businessSettingsStore': null,
        }
    },

    computed:{

        carrierManager(){
            // we've started defining whether or not we are the carrier manager separately, which is messy, so here is a unified way to add definitions into here

            return this.carrier_preselect || this.isCarrierManager;
        }
    },

    mounted() {

        const prefix = this.carrierManager ? 'carriermanager' : 'business';
        axios.get( `/${prefix}/settings?json=1` )
            .then( response => {

                this.businessSettingsStore = response.data;
            })
            .catch( err => {

                this.businessSettingsStore = {};
            });
    },

    methods: {

        businessSettings() {

            return this.businessSettingsStore;
        }
    },
}